import * as Sentry from '@sentry/react';
import { onCLS, onINP, onLCP } from 'web-vitals';

export function initObservability() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (dsn) {
    Sentry.init({
      dsn,
      environment: import.meta.env.MODE,
      tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    });
  }

  const report = (metric) => {
    if (import.meta.env.DEV) {
      console.debug('[web-vitals]', metric.name, metric.value);
    }
    if (dsn) {
      Sentry.metrics?.distribution?.(metric.name, metric.value, { unit: metric.name === 'CLS' ? '' : 'millisecond' });
    }
  };

  try {
    onCLS(report);
    onINP(report);
    onLCP(report);
  } catch (err) {
    console.warn('[web-vitals] init failed', err);
  }
}

export function captureException(error, context) {
  if (!import.meta.env.VITE_SENTRY_DSN) return;
  Sentry.captureException(error, context ? { extra: context } : undefined);
}
